export default __webpack_public_path__ + "static/media/Work Station.42d904bc.jpg";